<footer>
  @let footerData = footer;
  <div class="nav">
    <span>© Siemens AG {{ currentYear }}</span>
    <a href="{{ footerData.corporateInformation }}" target="_blank">
      {{ "footer.corporateInformation" | translate }}
    </a>
    <div class="privacy">
      <a href="{{ footerData.privacyNotice }}" target="_blank">
        {{ "footer.privacyNotice" | translate }}
      </a>
      /
      <a href="{{ footerData.intranetPrivacyNotice }}" target="_blank">
        {{ "footer.intranetPrivacyNotice" | translate }}
      </a>
    </div>
    <a href="{{ footerData.termsOfUse }}" target="_blank">
      {{ "footer.termsOfUse" | translate }}
    </a>
    <a href="{{ footerData.digitalId }}" target="_blank">
      {{ "footer.digitalId" | translate }}
    </a>
    <a href="{{ footerData.cookieNotice }}" target="_blank">
      {{ "footer.cookieNotice" | translate }}
    </a>
    <a href="{{ footerData.whistleblowing }}" target="_blank">
      {{ "footer.whistleblowing" | translate }}
    </a>
  </div>
  <div class="gms-container">
    <a class="gms" href="{{ footerData.gms }}" target="_blank">
      <span> powered by <strong>&#47;GMS&#47;</strong> </span>
    </a>
  </div>
</footer>
